import { useEffect, useState } from 'react';
import moment from 'moment';
import { api } from '@/api/client';
import { runAction } from '@/utils/errors';
import type { Session } from '@/types/session';

export const useUserSessions = () => {
  const [sessions, setSessions] = useState<Session[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    const from = moment().subtract(1, 'day').format('DD.MM.YYYY');

    runAction(
      async () => {
        const items = await api.get<Session[]>(`/api/session/findAllByUser?beginAt=${from}`, {
          signal: controller.signal,
        });
        setSessions(items ?? []);
      },
      { signal: controller.signal, onError: () => setError(true) },
    ).finally(() => {
      if (!controller.signal.aborted) setLoading(false);
    });

    return () => controller.abort();
  }, []);

  return { sessions, loading, error };
};
